export default __webpack_public_path__ + "images/216efdeff1197036ee1586adc4065635-auto.jpg";